import { useState, useEffect } from "react";
import { NAV_LINKS, HERO } from "../data/mock";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    if (location.pathname === "/") {
      // Already on home page — just scroll to anchor
      const id = href.replace("#", "");
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      // On another page — navigate home, then scroll after render
      navigate("/");
      setTimeout(() => {
        const id = href.replace("#", "");
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm border-b border-[#E0D1BB]/40"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-2">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 shrink-0" onClick={() => window.scrollTo(0, 0)}>
          <img
            src="/assets/logo-full.svg"
            alt="Asterisk Computer"
            className="h-[120px] w-auto"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
                scrolled
                  ? "text-[#494546] hover:text-[#308795]"
                  : "text-[#465155] hover:text-[#308795]"
              }`}
            >
              {link.label}
            </a>
          ))}
          <Link to="/consultation">
            <Button
              className="bg-[#308795] hover:bg-[#267580] text-white text-sm font-medium px-5 py-2.5 rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-[#308795]/20"
            >
              {HERO.primaryCTA.label}
            </Button>
          </Link>
        </nav>

        {/* Mobile Toggle */}
        <button
          className="lg:hidden p-2 text-[#494546]"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-[#E0D1BB]/40 shadow-lg">
          <nav className="flex flex-col px-6 py-4 gap-3">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => { handleNavClick(e, link.href); setMobileOpen(false); }}
                className="text-sm font-medium text-[#494546] hover:text-[#308795] py-2 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <Link to="/consultation" onClick={() => setMobileOpen(false)}>
              <Button className="w-full bg-[#308795] hover:bg-[#267580] text-white text-sm font-medium mt-2 rounded-lg">
                {HERO.primaryCTA.label}
              </Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};
